import React from "react";

export default function Footer() {
  return (
    <div className="bg-light footer-copyright text-center py-3 small">
      © 2022 by Esca Technologies Ltd. Company Number: 694871
    </div>
  );
}
